{
  "gain": 1,
  "pan": 0,
  "fx_EQ_isActive": true,
  "fx_EQ_low": 6.912000000000013,
  "fx_EQ_mid": 0,
  "fx_EQ_high": 0,
  "send_reverbA": -60,
  "send_reverbB": -60,
  "send_delayA": -60,
  "send_delayB": -60,
  "env_attack": 0.01,
  "env_decay": 0.045,
  "env_sustain": 0.469,
  "env_release": 0.6,
  "osc_waveform": "square",
  "lpf_cutoff": 12187.518045314411,
  "lpf_q": 0.7,
  "lfo_rate": 0.3,
  "lfo_depth": 0,
  "osc_octave": 0,
  "fx_distortion_amount": 0,
  "osc_portamento": 0,
  "osc_detune": 0.8,
  "_metadata": {
    "instrumentType": "synth_bass_wam"
  }
}